"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultStreamerOptions = void 0;
exports.DefaultStreamerOptions = {
    iceServers: [{ urls: 'stun:stun.l.google.com:19302' }],
    iceTransportPolicy: 'all',
    bandwidth: {
        minBitrateKbps: 3000,
        maxBitrateKbps: 20000,
        startingBitrateKbps: 10000
    },
    audio: {
        maxAverageBitrateKbps: 128000,
        stereo: 1
    },
    forceRelay: false
};
//# sourceMappingURL=StreamerOptions.js.map